import AllergiesTab from "./AllergiesTab";

export default AllergiesTab;